module.exports = __webpack_public_path__ + "media/images/icon-lock-7f1436e5d6a6bd1e0a738095841625e3.svg";